export default __webpack_public_path__ + "static/article-stay-healthy-over-the-festive-season-02bbe02374a6ff879dff68d15c0c7201.jpg";